@if (!rejected.length) {
  <p>{{ 'ORDERS.IMPORT.success' | translate }}</p>
} @else {
  <div>
    <p>
      <mat-icon color="primary">check</mat-icon>
    {{ 'ORDERS.IMPORT.created_count' | translate: { count: accepted.length } }}</p>
    <p>
      <mat-icon color="warn">close</mat-icon>
    {{ 'ORDERS.IMPORT.rejected_count' | translate: { count: rejected.length } }}</p>
    <div class="errors-view">
      @for (err of rejected; track err) {
        <dl>
          <dt><b>{{ 'ORDERS.COMMON.ORDER_ID.order_id_tooltip' | translate }}:</b> {{ err.id }}</dt>
          <dd>
            <div class="errors-wrapper">
              <div><b>{{ 'ORDERS.IMPORT.reasons' | translate }}</b></div>
              <div>
                @for (error of err.errors; track error) {
                  <div style="line-height: 20px">{{ error }}</div>
                }
              </div>
            </div>
          </dd>
        </dl>
      }
    </div>
  </div>
}

<app-button-group>
  <button color="warn" mat-dialog-close mat-flat-button>
    <mat-label>{{ 'QUERY_BUILDER.close' | translate }}</mat-label>
    <mat-icon>close</mat-icon>
  </button>
</app-button-group>
